<template>
  <v-card>
    <v-card-title>Color your Grid</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="8">
          <v-color-picker
            ref="colorPicker"
            v-model="color"
            dot-size="25"
            mode="hexa"
            :swatches="swatches"
            show-swatches
            hide-sliders
          />
        </v-col>
        <v-col cols="4">
          <v-btn block @click="color = white">White</v-btn>
          <v-btn block @click="clearGrid">Clear Colors</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col cols="4">
          <v-btn text @click="$store.commit('CREATOR/DECREMENT_STEP')">
            Back
          </v-btn>
        </v-col>
        <v-spacer />
        <v-col cols="4">
          <v-btn
            :color="$colors.blue"
            block
            class="white--text"
            @click="submit"
          >
            Submit
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    color: {
      alpha: 1,
      hex: "#5897a9",
      hexa: "#5897a9FF",
    },
    white: {
      alpha: 1,
      hex: "#FFFFFF",
      hexa: "#FFFFFFFF",
      hsla: { h: 0, s: 0, l: 1, a: 1 },
      hsva: { h: 0, s: 0, v: 1, a: 1 },
      hue: 0,
      rgba: { r: 255, g: 255, b: 255, a: 1 },
    },
  }),
  computed: {
    gridColors() {
      return this.$store.state.CREATOR.gridColors;
    },
    swatches() {
      return [
        [this.$colors.blue],
        [this.$colors["light-blue"]],
        [this.$colors.pink],
        [this.$colors.red],
        [this.$colors.orange],
        [this.$colors.purple],
        [this.$colors.green],
        [this.$colors.yellow],
      ];
    },
  },
  watch: {
    color: {
      handler() {
        this.$store.commit("CREATOR/COLOR_SET", this.color.hex);
      },
      immediate: true,
    },
    gridColors: {
      handler() {
        this.swatches.forEach(s => {
          let hue = s[0].substring(1, s[0].length);
          let swatchBlock = document.querySelector(`#color-${hue} div`);
          if (this.gridColors.toString().includes(hue)) {
            swatchBlock.classList.add("in-use");
          } else {
            swatchBlock.classList.remove("in-use");
          }
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.$store.commit("CREATOR/NUMBER_PLACEMENTS_SET", {});
    let swatches = document.querySelectorAll(".v-color-picker__color");
    for (let i = 0; i < swatches.length; i++) {
      let swatchColor = this.swatches[i][0].substring(
        1,
        this.swatches[i][0].length
      );
      swatches[i].id = `color-${swatchColor}`;
    }
  },
  methods: {
    clearGrid() {
      this.$store.commit("CREATOR/CLEAR_GRID");
    },
    submit() {
      this.$store.commit("CREATOR/INCREMENT_STEP");
    },
  },
};
</script>

<style>
.in-use {
  border: 3px black dotted !important;
}
</style>
